<form [formGroup]="targetForm" [ngClass]="{'form-previously-submitted' : targetFormSubmitted}">
    <header class="info-tile-alt heading-row">
        <div class="title-container">
            <h2>Edit Survey</h2>
        </div>
        <div class="drawer-close" (click)="closeRightSideDrawer()"><i class="fas fa-times" aria-hidden="true"></i></div>
    </header>
    <section class="sideRight-body">
        <label for="ei-surveyName" class="mt-2">
            <span><i class="fas fa-asterisk"></i> Survey Name</span>
            <span *ngIf="f.surveyName.errors && (f.surveyName.touched || f.surveyName.dirty)">
                <span class="required-error" *ngIf="f.surveyName.errors.required">(required)</span>
            </span>
            <input class="black-input opposite-colors" placeholder="Survey Name" type="text" no-special-chars="#!$%^<>+='" (change)="checkChangeName()"
            (blur)="trimSpecialChar('surveyName');noWhitespaceValidator();" maxlength="100" (input)="isChanged();noWhitespaceValidator();" formControlName="surveyName" required />
        </label>
        <div class="form-error-sign" *ngIf="f.surveyName.errors">
            <p *ngIf="f.surveyName.errors.required || !f.surveyName.valid">Survey Name is required.</p>
        </div>    
        <div class="ei-reminder-frequency mt-2"> 

            <label for="ei-reminder-frequency">
                Email Reminder Frequency
                <span *ngIf='reminderValue > 0'>({{reminderValue}} Days)</span>
                    <span *ngIf='reminderValue === 0'>(No Reminder)</span>
                <br />
                <div class="slidecontainer">
                    <!-- <ngx-slider 
            [options]="emailReminderFrequencyOptions"
            [(value)]="reminderValue" 
            formControlName="reminderFrequency" 
            (userChange)="sliderEvent($event)"
            ></ngx-slider> -->
                 
                </div>
            </label> 
            <div class="form-warning-sign" *ngIf="f.reminderFrequency.value===0">
                <p class="mt-0">* Email reminders will not be sent if frequency is set to zero.</p>
            </div>
            <div class="form-error-sign" *ngIf="!f.reminderFrequency.valid">
                <p class="mt-0">Email Reminder Frequency should be between 0 and 10.</p>
            </div>
        </div>

        <div class="ei-dueDate mt-2">
            <label for="ei-dueDate">
                <span><i class="fas fa-asterisk"></i> Due Date</span>
                <span class="input-group duedate-input">
                    <input type="text" class="black-input opposite-colors" no-special-chars="#!$%^<>+='"
                        [minDate]="minDate" 
                        [bsValue]="surveyDetails.dueDate"
                        placeholder="MM/DD/YYYY" bsDatepicker
                        [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                        formControlName="dueDate"  (bsValueChange)="setDueDate($event)"
                        #dpDueDate="bsDatepicker" style="opacity: 1;" required>
                    <span class="input-group-append">
                        <i class="fas fa-times input-group-append-i due-date" *ngIf="targetForm.value.dueDate"
                            (click)="clearDueDate()"></i>
                        <i *ngIf="!isRcnSurveyApp" class="fa fa-calendar-alt input-group-append-i" (click)="openDatePickerEnd()"></i>
                    </span>
                </span>
            </label>
            <div class="form-error-sign" *ngIf="f.dueDate.errors">
                <p *ngIf="f.dueDate.errors.required || !f.dueDate.valid">Due Date is required.</p>
            </div>  
        </div>

        <hr class="horizontal-line">

        <label for="ei-location" *ngIf="showProject" class="add-block">
            <span *ngIf="!addProject" class="add-header"
              (click)="expandProjects()">Add Projects +</span>
            <span *ngIf="addProject" class="add-header"
              (click)="addProject=false">Add Projects -</span>
            <div *ngIf="addProject">
                <div class="input-with-icon input-and-button">
                    <input #engagementSearch class="champion-search-input" placeholder="Search Projects" type="text"
                        [container]="'#projectTypeAhead'" no-special-chars="#!$@%^<>+=" [kpmgUiTypeahead]="searchProjects"
                        [resultTemplate]="unassignedPrj" [editable]="false" (selectItem)="onProjectSelected($event.item)"
                        [inputFormatter]="projectFormatter" />
                    <div class="link-button-top-border mgl10" *ngIf="showAddNewProjectButton" (click)="addNewProjectButtonClick()">
                        <a><i class="fas fa-plus"></i> Add New Project</a>
                    </div>
                </div>
                <ng-template #unassignedPrj let-r="result" let-t="term">
                    <kpmg-ui-highlight [result]="r.name" [term]="t"></kpmg-ui-highlight>
                </ng-template>
                <div *ngIf="assignedProjects !== undefined && assignedProjects.length > 0" class="item-list">
                    <ng-container *ngTemplateOutlet="tListOfItems; 
                        context: {_assignedItems: assignedProjects, _deleteMethod: 'deleteProject'}">
                    </ng-container>
                </div>
            </div>
            <hr class="horizontal-line">
        </label>

        <label for="ei-location" *ngIf="showActivity" class="add-block">
            <span *ngIf="!addActivity" class="add-header"
              (click)="expandActivities()">Add Activities +</span>
            <span *ngIf="addActivity" class="add-header"
              (click)="addActivity=false">Add Activities -</span>
            <div *ngIf="addActivity">
                <div class="input-with-icon">
                    <input #engagementSearch class="champion-search-input" placeholder="Search Activity" type="text"
                        [container]="'#activityTypeAhead'" no-special-chars="#!$@%^<>+="
                        [kpmgUiTypeahead]="searchActivity" [resultTemplate]="unassignedAct" [editable]="false"
                        (selectItem)="onActivitySelected($event.item)" [inputFormatter]="activityFormatter"/>
                </div>
                <ng-template #unassignedAct let-r="result" let-t="term">
                    <kpmg-ui-highlight [result]="r.name" [term]="t"></kpmg-ui-highlight>
                </ng-template>
                <div *ngIf="assignedActivity !== undefined && assignedActivity.length > 0" class="item-list">
                    <ng-container *ngTemplateOutlet="tListOfItems; 
                        context: {_assignedItems: assignedActivity, _deleteMethod: 'deleteActivity'}">
                    </ng-container>
                </div>
            </div>
            <hr class="horizontal-line">
        </label>

        <label for="ei-location" class="add-block">
            <span *ngIf="!addNQAActivity" class="add-header"
              (click)="expandNQAActivities()">Add NQAs +</span>
            <span *ngIf="addNQAActivity" class="add-header"
              (click)="addNQAActivity=false">Add NQAs -</span>
            <div *ngIf="addNQAActivity">
                <div class="input-with-icon">
                    <input #engagementSearch class="champion-search-input" placeholder="Search NQA Activity" type="text"
                        [container]="'#NQAActivityTypeAhead'" no-special-chars="#!$@%^<>+="
                        [kpmgUiTypeahead]="searchNQAActivity" [resultTemplate]="unassignedNQAAct" [editable]="false"
                        (selectItem)="onNQAActivitySelected($event.item)" [inputFormatter]="activityNQAFormatter"/>
                </div>
                <ng-template #unassignedNQAAct let-r="result" let-t="term">
                    <kpmg-ui-highlight [result]="r.name" [term]="t"></kpmg-ui-highlight>
                </ng-template>
                <div *ngIf="assignedNQAActivity !== undefined && assignedNQAActivity.length > 0" class="item-list">
                    <ng-container *ngTemplateOutlet="tListOfItems; 
                        context: {_assignedItems: assignedNQAActivity, _deleteMethod: 'deleteNQAActivity'}">
                    </ng-container>
                </div>
            </div>
            <hr class="horizontal-line">
        </label>
        
        <label for="ei-location" class="add-block">
            <span *ngIf="!addNWTActivity" class="add-header" (click)="expandNWTActivities()">Add NWTs +</span>
            <span *ngIf="addNWTActivity" class="add-header" (click)="addNWTActivity=false">Add NWTs -</span>
            <div *ngIf="addNWTActivity">
                <div class="input-with-icon">
                    <input #engagementSearch class="champion-search-input" placeholder="Search NWT Activity" type="text"
                        [container]="'#NWTActivityTypeAhead'" no-special-chars="#!$@%^<>+="
                        [kpmgUiTypeahead]="searchNWTActivity" [resultTemplate]="unassignedNWTAct" [editable]="false"
                        (selectItem)="onNWTActivitySelected($event.item)" [inputFormatter]="activityNWTFormatter" />
                </div>
                <ng-template #unassignedNWTAct let-r="result" let-t="term">
                    <kpmg-ui-highlight [result]="r.name" [term]="t"></kpmg-ui-highlight>
                </ng-template>
                <div *ngIf="assignedNWTActivity !== undefined && assignedNWTActivity.length > 0" class="item-list">
                    <ng-container *ngTemplateOutlet="tListOfItems; 
                                context: {_assignedItems: assignedNWTActivity, _deleteMethod: 'deleteNWTActivity'}">
                    </ng-container>
                </div>
            </div>
        </label>
        
    </section>
    <footer class="endFormSubmit info-tile">
        <button type='button' class="btn btn-success" (click)="submitButtonClick()"
            [disabled]="!targetForm.valid || isDisabled">Save</button>
        <button class="btn kpmg-button--flat" (click)="closeRightSideDrawer()">Cancel</button>
    </footer>
</form>

<add-user-model *ngIf="showAddUserModel" 
    (modelStatusHandler)="closeModel($event)"
    (user)="bindNewuser($event)"
    [isSME]= 'isSME' 
    [addUserName]='addUserName' 
    [clientName]='clientName'>
</add-user-model>

<!---------------------------------- template for tListOfItems ---------------------------------->
<ng-template #tListOfItems let-assignedItems="_assignedItems" let-deleteMethod="_deleteMethod">
    <div *ngFor="let row of assignedItems" class="item-list-row">
        {{row.name}}
        <div>
            <span *ngIf="!row.isLocked" class="link-button" (click)="deleteRow(row, deleteMethod)">
                <i class="fa fa-trash fail-color"></i>
            </span>
            <span *ngIf="row.isLocked" class="link-button" [attr.disabled]="row.isLocked">
                <i class="fa fa-trash grey-color"></i>
            </span>
        </div>
    </div>
</ng-template>
<!--------------------------------- template for tListOfItems end--------------------------------->